import script from "./timeAddress.vue?vue&type=script&setup=true&lang=js"
export * from "./timeAddress.vue?vue&type=script&setup=true&lang=js"

import "./timeAddress.vue?vue&type=style&index=0&id=28e59ca1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28e59ca1"]])

export default __exports__